import React from 'react'

const frameStyle = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'block',
  pointerEvents: 'none'
}

const imageStyle = {
  width: '100%',
  height: '100%',
  display: 'block',
  objectFit: 'cover',
  filter: 'brightness(0.62)'
}

const ThemeHeroImage = ({ desktop, mobile, alt = '' }) => (
  <picture style={frameStyle} aria-hidden={alt === '' ? 'true' : undefined}>
    {mobile ? <source media="(max-width: 767px)" srcSet={mobile} /> : null}
    <img src={desktop} alt={alt} style={imageStyle} />
  </picture>
)

export default ThemeHeroImage



// WEBPACK FOOTER //
// ./src/components/ThemeHeroImage.js